// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","dataToMakeYouBetter":"dataToMakeYouBetter-2bJCL","screen":"screen-3OcBt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/data-to-make-you-better/_dataToMakeYouBetter.css
// module id = 1170
// module chunks = 1